var render = function render(){
  var _vm$filters, _vm$filters2, _vm$filters3, _vm$filters4, _vm$filters5, _vm$filters6, _vm$filters7, _vm$filters8, _vm$filters9, _vm$filters0, _vm$filters1, _vm$filters10, _vm$filters11, _vm$filters12, _vm$filters13;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-col', {
    staticClass: "my-3",
    staticStyle: {
      "padding": "0 30px"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('b-row', {
    staticClass: "border rounded-md pt-2"
  }, [(_vm$filters = _vm.filters) !== null && _vm$filters !== void 0 && _vm$filters.dateRange.length ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Period :"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "mb-0 text-black",
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s((_vm$filters2 = _vm.filters) !== null && _vm$filters2 !== void 0 && _vm$filters2.dateRange[0] ? _vm.moment((_vm$filters3 = _vm.filters) === null || _vm$filters3 === void 0 ? void 0 : _vm$filters3.dateRange[0]).format('DD MMM YYYY') : '') + " - "), _c('span', [_vm._v(" " + _vm._s((_vm$filters4 = _vm.filters) !== null && _vm$filters4 !== void 0 && _vm$filters4.dateRange[1] ? _vm.moment((_vm$filters5 = _vm.filters) === null || _vm$filters5 === void 0 ? void 0 : _vm$filters5.dateRange[1]).format('DD MMM YYYY') : '') + " ")])])])])], 1) : _vm._e(), (_vm$filters6 = _vm.filters) !== null && _vm$filters6 !== void 0 && _vm$filters6.vehicleTypeIds.length ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fleet Category :"
    }
  }, [_vm._l((_vm$filters7 = _vm.filters) === null || _vm$filters7 === void 0 ? void 0 : _vm$filters7.vehicleTypeIds, function (type, index) {
    return _c('b-badge', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "variant": "success"
      }
    }, [_vm._v(" " + _vm._s(type.name) + " ")]);
  })], 2)], 1) : _vm._e(), (_vm$filters8 = _vm.filters) !== null && _vm$filters8 !== void 0 && _vm$filters8.vehicleIds.length ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fleet Name :"
    }
  }, [_vm._l((_vm$filters9 = _vm.filters) === null || _vm$filters9 === void 0 ? void 0 : _vm$filters9.vehicleIds, function (type, index) {
    return _c('b-badge', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "variant": "warning"
      }
    }, [_vm._v(" " + _vm._s(type.name) + " ")]);
  })], 2)], 1) : _vm._e(), _vm.filters.filterJobType === 'jobClass' && (_vm$filters0 = _vm.filters) !== null && _vm$filters0 !== void 0 && _vm$filters0.jobClassIds.length ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Job Class :"
    }
  }, _vm._l((_vm$filters1 = _vm.filters) === null || _vm$filters1 === void 0 ? void 0 : _vm$filters1.jobClassIds, function (type, index) {
    return _c('b-badge', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "variant": "danger"
      }
    }, [_vm._v(" " + _vm._s(type.name) + " ")]);
  }), 1)], 1) : _vm._e(), _vm.filters.filterJobType === 'jobType' && (_vm$filters10 = _vm.filters) !== null && _vm$filters10 !== void 0 && _vm$filters10.jobTypeIds.length ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Job Type :"
    }
  }, _vm._l((_vm$filters11 = _vm.filters) === null || _vm$filters11 === void 0 ? void 0 : _vm$filters11.jobTypeIds, function (type, index) {
    return _c('b-badge', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "variant": "danger"
      }
    }, [_vm._v(" " + _vm._s(type.name) + " ")]);
  }), 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status :"
    }
  }, [_c('p', {
    staticClass: "mb-0 text-black",
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s((_vm$filters12 = _vm.filters) !== null && _vm$filters12 !== void 0 && _vm$filters12.status ? _vm.statusText((_vm$filters13 = _vm.filters) === null || _vm$filters13 === void 0 ? void 0 : _vm$filters13.status) : 'All') + " ")])])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }